import '../index.scss';

import clsx from 'clsx';
import { CSSProperties, MouseEvent, ReactElement, useEffect, useRef, useState } from 'react';

export interface CopyableTextProps {
  dataTestId?: string;
  style?: CSSProperties;
  className?: string;
  text: string | number;
}

export const CopyableText = (props: CopyableTextProps): ReactElement => {
  const [copied, setCopied] = useState(false);

  const { dataTestId, style, className, text } = props;
  const timeoutRefDisplay = useRef<ReturnType<typeof setTimeout> | null>(null);

  const copy = (event: MouseEvent<HTMLSpanElement>) => {
    const win = event.currentTarget.ownerDocument.defaultView ?? window;
    win.navigator.clipboard.writeText(String(text)).then(
      () => {
        setCopied(true);
        timeoutRefDisplay.current = setTimeout(() => void setCopied(false), 3000);
      },
      (err: Error) => {
        alert(`Data copy failed: ${err.message}`);
      },
    );
  };

  useEffect(
    () => () => {
      if (timeoutRefDisplay.current) {
        clearTimeout(timeoutRefDisplay.current);
        timeoutRefDisplay.current = null;
      }
    },
    [],
  );

  return (
    <span
      data-testid={dataTestId}
      style={style}
      className={clsx('windows_tooltip', className)}
      onClick={(event) => {
        event.stopPropagation();
        copy(event);
      }}
    >
      <span className="windows_tooltiptext" style={{ width: copied ? '62px' : '47px' }}>
        {copied ? 'Copied!' : 'Copy'}
      </span>
      {text}
    </span>
  );
};
